// 折线图
export default {
  name: '柱状图',
  type: 'bar',
  option: (data) => ({
    xAxis: {
      type: 'category',
      axisTick: {
        show: false,
      },
      data: data.x,
    },
    grid: {
      containLabel: true,
      left: 10,
      right: 10,
      top: 30,
      bottom: 20,
    },
    yAxis: {
      type: 'value',
    },
    tooltip: {
      trigger: 'axis',
    },
    series: data.y.map((item) => ({
      type: 'bar',
      ...item,
    })),
  }),
};
